import React, { useState, useEffect } from 'react';
import { BiPlus } from 'react-icons/bi';
import { CgClose } from 'react-icons/cg';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Form/Input';
import { RESUME_API_END_POINT } from "../../../../../utils/constant";
import axios from 'axios';
import Select from '../../../../../components/Form/Select';
import TagInput from '../../../../../components/Form/TagInput';
import { useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';

const Qualities = ({data, setData}) => {
    const [showModal, setShowModal] = useState(false);
    const [qualities, setQualities] = useState(data?.qualities || []);
    const [newQuality, setNewQuality] = useState('');
    const [editingQuality, setEditingQuality] = useState(null);
    const {user} = useSelector(store=>store.user)
    const {showNotif, setShowNotif} = useOutletContext()

    useEffect(() => {
        // if (data) {
        //   setQualities(data?.qualities)
        // }

        if (Array.isArray(data?.qualities)) {
            setQualities(data.qualities);
        } else {
            setQualities([]); // S'assurer que c'est toujours un tableau
        }
      }, [data]);

    // Add new quality
    const addQuality = async () => {
        console.error("Add quality quality:", newQuality);
        try {
            const response = await axios.post(`${RESUME_API_END_POINT}/qualities`, { name: newQuality });
            setQualities([...qualities, response.data]);
            setShowModal(false);
            setNewQuality('');
        } catch (error) {
            console.error("Error adding quality:", error);
        }
    };

    // Edit an existing quality
    const editQuality = async () => {
        // try {
        console.log("Data submited", qualities)
            await axios.post(`${RESUME_API_END_POINT}/qualities/update/${user?.id}`, { qualities: qualities })
            .then((response)=>{
                console.log(response.data)
                setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
                // setQualities(qualities.map(quality => quality.id === editingQuality.id ? { ...quality, name: newQuality } : quality));
                // setShowModal(false);
                // setEditingQuality(null);
                // setNewQuality('');
            })
            .catch ((error)=> {
            setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
            console.error("Error editing quality:", error);
        })
    };

    // Delete quality
    const deleteQuality = async (id) => {
        try {
            await axios.delete(`${RESUME_API_END_POINT}/qualities/${id}`);
            setQualities(qualities.filter(quality => quality.id !== id));
        } catch (error) {
            console.error("Error deleting quality:", error);
        }
    };

    // Handle open modal for add/edit
    const handleOpenModal = (quality = null) => {
        setEditingQuality(quality);
        setNewQuality(quality ? quality.name : '');
        setShowModal(true);
    };

    // Handle save button action
    const handleSaveQuality = () => {
        if (editingQuality) {
            editQuality();
        } else {
            addQuality();
        }
    };

    return (
        <div className="flex-col text-start border p-4 rounded-md">
            <div className="flex justify-between items-center mb-4">
                <div className='font-semibold'>Qualités</div>
                <button onClick={() => editQuality()} className="bg-neutral-50 border rounded-sm p-1">
                    <BiPlus className='w-5 h-5 text-neutral-500' /> Enregistrer
                </button>
            </div>
           
            <TagInput tags={qualities} setTags={(value)=>setQualities(value)} />
            
            {/* Modal for adding/editing quality */}
            <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                <div className="flex items-center justify-between py-2 px-4">
                    <p>{editingQuality ? 'Modifier' : 'Ajouter'} une compétence</p>
                    <button onClick={() => setShowModal(false)} className='px-2 py-2 rounded-md border text-primary-black'>
                        <CgClose />
                    </button>
                </div>
                <hr className='mb-6' />
                <div className="px-6 space-y-4 mb-4">

                    <Select 
                    placeholder='Veuillez sélectionner une compétence'
                    options={["Figma"]}
                    label='Compétence' 
                    value={newQuality} 
                    onChange={(e) => setNewQuality(e.target.value)} 
                    />
                </div>
                <div className="flex items-center justify-end p-6">
                    <button onClick={handleSaveQuality} className="py-2 px-6 rounded-sm shadow bg-primary-black text-white">
                        Enregistrer
                    </button>
                </div>
            </Modal>    
        </div>
    );
}

export default Qualities;
